import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CtaButton } from "./CtaButton";
export function MobileCtaBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const nearBottom = window.innerHeight + window.scrollY > document.body.scrollHeight - 700;
      setVisible(window.scrollY > 700 && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-17" data-mp="1aa0v8aitj5ny">
      {visible && <motion.div initial={{
      y: "100%"
    }} animate={{
      y: 0
    }} exit={{
      y: "100%"
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-ink/95 px-4 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 backdrop-blur md:hidden" data-id="element-18" data-mp="1a87oywc4angh">
          <div className="flex items-center gap-3" data-id="element-19" data-mp="3f9il0evueeak">
            <div className="shrink-0 leading-tight" data-id="element-20" data-mp="3f8z491hxhvy4">
              <p className="font-display text-lg font-black" data-id="element-21" data-mp="3b7nemvz21apx">$97<span className="text-xs font-bold text-mute" data-id="element-22" data-mp="3b8yp1en09gq0">/mes</span></p>
              <p className="text-[11px] text-mute" data-id="element-23" data-mp="36g5mmxf0ekh3">Cancela cuando quieras</p>
            </div>
            <div className="min-w-0 flex-1" data-id="element-24" data-mp="31haqyuvy11fk">
              <CtaButton label="Entrar a CLARIFY" data-id="element-25" data-mp="31gj7ujjj8w66" />
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}